import  type { Dispatch, SetStateAction } from 'react';
import Vector from "../../images/Vector.svg";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from './select';
import { FlagUnitedStates, FlagCanadaIcon } from "../shared/SMBIcons";

type LanguageSwitchProps = {
    language: string;
    setLanguage: Dispatch<SetStateAction<string>>;
    withViewportPadding?: boolean;
}

const languageLabels: Record<string, { short: string; flag: typeof FlagUnitedStates }> = {
    "en-us": { short: "English", flag: FlagUnitedStates },
    "en-ca": { short: "English", flag: FlagCanadaIcon },
    "fr-ca": { short: "Français", flag: FlagCanadaIcon },
};

const LanguageSwitch = ({ language, setLanguage, withViewportPadding = false }: LanguageSwitchProps) => {
    const selected = languageLabels[language] ?? languageLabels["en-us"];
    const Flag = selected.flag;
    return (
        <Select defaultValue={localStorage.getItem("language") || 'en-us'} value={language} onValueChange={setLanguage}>
            <SelectTrigger className="border-0 w-fit [&>svg]:none [&>span]:line-clamp-none [&>span]:flex" aria-label="Select Language">
                <span className="flex items-center gap-2 whitespace-nowrap">
                    <Flag className="w-auto h-4 shrink-0" />
                    {selected.short}
                </span>
                <img src = {Vector} alt="arrow" className='ml-2'/>
            </SelectTrigger>
            <SelectContent withViewportPadding={withViewportPadding}>
                <SelectGroup>                    
                    {/* <SelectItem value="en-us">{language === "en-us" ? "English" : "Anglais"}</SelectItem>
                    <SelectItem value="fr-ca">{language === "en-us" ? "French" : "Français"}</SelectItem> */}
                    <SelectItem value="en-us" className="w-[230px] h-[49px] gap-3 opacity-100 border-b border-b-[#CCCCD2] pt-3 pr-4 pb-3 pl-4">
                        <span className="flex items-center gap-2">
                            <FlagUnitedStates className="w-auto h-4" />
                            United States - English
                        </span>
                    </SelectItem>
                    <SelectItem value="en-ca" className="w-[230px] h-[49px] gap-3 opacity-100 border-b border-b-[#CCCCD2] pt-3 pr-4 pb-3 pl-4">
                        <span className="flex items-center gap-2">
                            <FlagCanadaIcon className="w-auto h-4" />
                            Canada - English
                        </span>
                    </SelectItem>
                    <SelectItem value="fr-ca" className="w-[230px] h-[49px] gap-3 opacity-100 border-b border-b-[#CCCCD2] pt-3 pr-4 pb-3 pl-4">
                        <span className="flex items-center gap-2">
                            <FlagCanadaIcon className="w-auto h-4" />
                            Canada - Français
                        </span>
                    </SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    )
}

export { LanguageSwitch }
